import { FC } from 'react'
import SimpleLoader from '../../../apps/components/SimpleLoader'
import { IElevatorPitchStakeholder } from '../../../core/_models'

type Props = {
    submitLoader: boolean
    stakeholders: IElevatorPitchStakeholder[]
}

const IdentifyKeyStakeholders: FC<Props> = ({ submitLoader, stakeholders }) => {
    return (
        <div className="w-100 position-relative mt-3">
            {submitLoader && <SimpleLoader />}
            <div className="table-responsive">
                <table className="table table-bordered border-secondary w-100">
                    <thead>
                        <tr className="bg-secondary align-middle">
                            <th className="text-gray-700">#</th>
                            <th className="text-gray-700">Stakeholder Name</th>
                            <th className="text-gray-700">Role & Responsibility</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stakeholders.length === 0 ? (
                            <tr>
                                <td colSpan={3} className="text-center">No data added yet.</td>
                            </tr>
                        ) : (
                            stakeholders.map((row, index) => (
                                <tr key={row.stakeholder_id ?? index}>
                                    <td>{index + 1}</td>
                                    <td>{row.stakeholder_name}</td>
                                    <td>{row.roles_and_responsibilities}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export { IdentifyKeyStakeholders }
